import React from 'react';

type Twikey = {
  className: string;
};

export const TwikeyIcon: React.FC<Twikey> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="1.41"
    clipRule="evenodd"
    viewBox="0 0 261 115"
    className={props.className}
  >
    <defs />
    <path
      fill="#1b407d"
      fillRule="nonzero"
      d="M5.08 68.85H.76v-7h4.32v-7.6l8.7-3.2v10.8h7.58l2.66 7H13.78v16.33c0 2.67.42 4.55 1.26 5.65.83 1.1 2.3 1.66 4.38 1.66 2.1 0 4.04-.6 5.85-1.8v8c-2.02.7-4.9 1-8.63 1-3.72 0-6.57-1.08-8.57-3.18s-3-5.1-3-8.96V68.8zm61.07 30.98h-3.18l-10.23-22.9-10.2 22.9h-3.2L25.27 61.85h9.16L41.9 84.1l9.14-22.25h3.13l9.43 22.4 8.08-22.4h8.56l-14.1 37.98zm20-.7V69h-4.78l3.03-7.13h10.55v37.3h-8.8zM144.3 76.6h18.32c-.6-5.44-3.62-8.17-9.05-8.17-4.96 0-8.06 2.73-9.26 8.18zm26.33 6.56H144c.16 2.97 1.18 5.28 3.06 6.93 1.88 1.6 4.4 2.4 7.6 2.4 3.96 0 6.98-1.1 9.05-3.1l3.4 6.6c-3 2.5-7.6 3.7-13.7 3.7-5.7 0-10.2-1.7-13.5-5-3.3-3.36-4.9-8-4.9-13.98 0-5.9 1.8-10.65 5.5-14.3 3.66-3.64 8-5.46 13.1-5.46 5.4 0 9.75 1.6 13.03 4.83 3.25 3.2 4.9 7.32 4.9 12.3 0 1.07-.26 2.7-.75 4.85zm21.02 21.97c-.93 2.48-2.92 4.54-5.97 6.18-3.06 1.7-6.6 2.5-10.67 2.5v-7.7c6.7 0 10.1-1.6 10.1-5 0-2.2-.9-5.6-2.8-10.2l-11.7-29h9.1l10.15 25.7L199 61.9h9l-16.34 43.28z"
    />
    <path
      fill="#1b407d"
      fillRule="nonzero"
      d="M127.3 99.14l-15.15-22.98 12.44-14.3H135l-12.6 14.12 15.18 23.16h-10.3zm-16.37 0h-8.7v-51.2l8.7-2.08v53.28z"
    />
    <path
      fill="url(#a)"
      d="M220.8 20.74c-.07-.65-.25-1.35-.54-2-1.64-5.08-5.88-10.88-14.47-16-5.6-3.3-9-1.36-7.5 3.95.9 3.3 2.6 5 3.3 8.6.7 3.6-3 9 1.6 12.7-1.5 3-2.9 6.2-3.9 8.9-1.3 3.4-.2 7.32 6.2 7.33 14.6 0 17.4-13.67 15.16-23.66z"
    />
    <path
      fill="url(#b)"
      d="M254.35 23.1c-9.7-2.37-16.8-1.2-21.53 1.3-.66.25-1.27.62-1.78 1.05-8.57 5.57-16.15 17.3-5.7 27.5 4.62 4.52 8.18 2.46 9.6-.87 1.17-2.7 2.44-5.9 3.48-9.14 5.85.58 7.08-5.9 10.08-7.97 2.98-2.06 5.37-2.16 8.38-3.88 4.8-2.8 3.75-6.5-2.53-8z"
    />
    <path
      fill="#1b407d"
      fillRule="nonzero"
      d="M95.12 50.3c0 2.6-2.1 4.7-4.68 4.7-2.58 0-4.67-2.1-4.67-4.7 0-2.57 2.1-4.67 4.67-4.67 2.6 0 4.68 2.1 4.68 4.68z"
    />
    <defs>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="rotate(106.856 104.756 81.74) scale(40.6765)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#cd2b27" />
        <stop offset="1" stopColor="#f68b1e" />
      </linearGradient>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="rotate(106.856 117.327 98.685) scale(40.6748)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#cd2b27" />
        <stop offset="1" stopColor="#f68b1e" />
      </linearGradient>
    </defs>
  </svg>
);
